(function () {
  'use strict';

  function initLoadMore(root) {
    var button = root.querySelector('[data-nr-wall-load-more]');
    var list = root.querySelector('[data-nr-wall-reviews]');
    if (!button || !list) return;

    var batch = Number(root.dataset.batchSize || 24);
    var visible = batch;

    function getReviewItems() {
      return list.querySelectorAll('[data-nr-wall-review]');
    }

    function update() {
      var reviewItems = getReviewItems();
      reviewItems.forEach(function (item, index) {
        item.hidden = index >= visible;
      });
      button.hidden = visible >= reviewItems.length;
    }

    button.addEventListener('click', function () {
      visible += batch;
      update();
    });

    update();
  }

  function initModal(root) {
    var modal = root.querySelector('[data-nr-modal]');
    if (!modal) return;

    var modalImage = modal.querySelector('[data-nr-modal-image]');
    var closeButton = modal.querySelector('[data-nr-modal-close]');

    function openModal(src) {
      modalImage.src = src;
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      modal.classList.remove('is-open');
      modalImage.removeAttribute('src');
      document.body.style.overflow = '';
    }

    root.querySelectorAll('[data-nr-open-modal]').forEach(function (node) {
      node.addEventListener('click', function () {
        openModal(node.dataset.nrOpenModalSrc || node.src);
      });
    });

    if (closeButton) closeButton.addEventListener('click', closeModal);
    modal.addEventListener('click', function (event) {
      if (event.target === modal) closeModal();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });
  }

  function initWall(root) {
    if (root.dataset.nrWearNothingWallInit) return;
    root.dataset.nrWearNothingWallInit = 'true';

    initLoadMore(root);
    initModal(root);

    if (window.NrWearNothing && typeof window.NrWearNothing.init === 'function') {
      window.NrWearNothing.init(root);
    }
  }

  function initAll() {
    document.querySelectorAll('[data-nr-wear-nothing-wall]').forEach(initWall);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-nr-wear-nothing-wall]').forEach(initWall);
  });
})();
